import * as yup from 'yup';

export const SMARTeSchema = yup.object().shape({
    smartE: yup
        .string()
        .ensure()
        .required('SMARTe is required')
});
